// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { translate } from '@tectonics/translate';

export function MessageFinishYourPayment(): Node {
  return <FinishYourPaymentMessage />;
}

function FinishYourPaymentMessage(): Node {
  return (
    <Root>
      {translate('volcanes.finishYourPaymentMessage')}
    </Root>
  );
}

const Root = styled.div`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.25rem;
  @media (max-width: 840px){
    display: none;
  }
`;
